import get from 'transmute/get';
export const getSpamFilteringAndBlocking = get('spamFilteringAndBlocking');